
import { ToastPanel } from '@twago/toast'

export default {
  name: 'Portal',

  components: { ToastPanel },
  middleware: 'profile-fullfilled',

  head() {
    return this.$clientI18nSeo()
  },
  watch: {
    '$nuxt.isFetching': {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$triggerLoader('PAGE', false)
        }
      }
    }
  },
  // mounted() {
  //   // const siteKey = this.$config.recaptchaSiteKey
  //   const siteKey = '6Lfx5I4rAAAAACiXwydjjTeW8cNYiUh-G80h2tfB'
  //   console.log('siteKey', siteKey)
  //   console.log('process.env.RECAPTCHA', this.$config.recaptchaSiteKey)
  //   if (
  //     !document.querySelector(
  //       `script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`
  //     )
  //   ) {
  //     const script = document.createElement('script')
  //     script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
  //     script.async = true
  //     script.defer = true
  //     script.onload = () => {
  //       console.log('reCAPTCHA script loaded')
  //     }
  //     document.head.appendChild(script)
  //   }
  // },

  beforeDestroy() {
    this.$toast.show = false
  }
}
